import React, {useState} from "react";
import {withTranslation} from "react-i18next";
import {
    LogoutOutlined
} from '@ant-design/icons';

import "../../tek.scss";
import {Button} from 'antd';
import {history} from '_helpers/history'
import StepTekTwo from "./stepTekTwo";
import StepTekThree from "./stepTekThree";
import StepTekFour from "./stepTekFour";
import StepTekFive from "./stepTekFive";
import StepTekSix from "./stepTekSix";
import StepTekSeven from "./stepTekSeven";
import StepTekEight from "./stepTekEight";
import StepTekNine from "./stepTekNine";
import StepTekTen from "./stepTekTen";
import {xcService} from "../../../../../../_services/xcService";


function StepTekOne(props) {

    const {t} =props;
    const [step, setStep] = useState(1);
    const goTo = (number) => {

        setStep(number)
    }

    const saveGamed = () => {
        xcService.putToken("/v1/savegame", {quest: 'quest3'}).then( (data ) => {
            setStep(2);
        }).catch( (err) =>  setStep(2))


    }
    return (
<>
    {step === 1 &&

        <div className={"backGroundTek first"}>
            <div className={"wrapper boxed"}>
                <div className={"insideTek boxed"}>
                    <Button
                      onClick={() => history.push("/admin/assessment")}
                      className="primaryButton btn-icon-text" icon={<LogoutOutlined/>}>{t("exit")}</Button>
                </div>
                <div className={"initTek"}>
                    <h2 className={"title-xs"}>{t("tek.title")}</h2>
                    <h3>{t("tek.antes")} <strong>{t("tek.quequieres")}</strong></h3>
                    <div className={"content-cards"}>
                        <div className={"card"}>
                            <div className={"chooseOp"}>
                                <img src={"/assets/img/ciudadtek.png"} onClick={() => history.push("/admin/assessment")}/>
                                <Button type={"primary"}
                                        onClick={() => saveGamed()}
                                        className="primaryButton">{t("tek.conocer")}</Button>
                            </div>
                        </div>
                        <div className={"card"}>
                            <div className={"chooseOp"}>
                                <img src={"/assets/img/goquestion3.png"} onClick={() => history.push("/admin/start-tek")}/>
                                <Button
                                        onClick={() => history.push("/admin/tek-instructions")}
                                        className="primaryButton">{t("tek.ird")}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    {step === 2 &&
            <StepTekTwo goTo={goTo} />
    }
    {step === 3 &&
        <StepTekThree goTo={goTo} />
    }
    {step === 4 &&
        <StepTekFour goTo={goTo} />
    }
    {step === 5 &&
        <StepTekFive goTo={goTo} />
    }
    {step === 6 &&
        <StepTekSix goTo={goTo} />
    }
    {step === 7 &&
        <StepTekSeven goTo={goTo} />
    }
    {step === 8 &&
        <StepTekEight goTo={goTo} />
    }
    {step === 9 &&
        <StepTekNine goTo={goTo} />
    }
    {step === 10 &&
        <StepTekTen goTo={goTo} />
    }
</>

    )
}

export default withTranslation()(StepTekOne);
